import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { Table } from 'components/common/Elements/Elements';

const TableCell = ({ children, cellProps, ...other }) => {
  const { row, mouseEnter, field, ind, classes } = cellProps;
  return (
    <Table.Cell
      className={cn(
        classes.tableCell,
        row === `r${ind}` && classes.hov,
        classes[field]
      )}
      onMouseEnter={mouseEnter}
      {...other}
    >
      {children}
    </Table.Cell>
  );
};

TableCell.propTypes = {
  children: PropTypes.node,
  cellClass: PropTypes.string,
  cellProps: PropTypes.shape({
    ind: PropTypes.number,
    field: PropTypes.string,
    row: PropTypes.string,
    mouseEnter: PropTypes.func,
    classes: PropTypes.object
  })
};

export default TableCell;
